var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.items.length
    ? _c(
        "section",
        {
          staticClass: "d-flex flex-column",
          class: _setup.isMobile ? "ga-5" : "ga-6",
          attrs: { id: "related-lpus", "data-qa": "lpu_related_clinics" },
        },
        [
          _c(
            "h2",
            {
              staticClass: "text--text",
              class: _setup.isMobile ? "text-h6" : "text-h5",
              attrs: { "data-qa": "lpu_related_clinics_title" },
            },
            [
              _vm._v(
                "\n    " + _vm._s(_setup.tStatic("Связанные клиники")) + "\n  "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            _vm._l(_vm.items, function (clinic, index) {
              return _c(_setup.RelatedClinicItem, {
                key: clinic.url || `${clinic.name}-${index}`,
                attrs: { clinic: clinic, "is-striped": index % 2 === 0 },
              })
            }),
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }